import React from "react";
import AppLayout from "../components-app/AppLayout";
import OverviewList from "../components-static/OverviewList";
import {
  PageMenu,
  DeleteListItem,
  GenerateSpreadsheet,
  MobileMenu,
  Step,
  LoadGraphic,
} from "../components-static/Common";
import {
  EditSizeLabel,
  EditableBox,
  EditableSelect,
  Box,
  Button,
} from "../components-static/Input";
import u from "../utilities/Utilities";
import { YesNoSelect, ContractorPurpose } from "../data/Options";
import "../styles/staff-list.scss";
import moment from "moment";
import { enabled } from "store";

export default class ContractorList extends React.Component {
  state = {
    selected: {
      tags: [],
      all: false,
      data: [],
      entryCount: 0,
    },
    pageMenuButtons: [],
    spreadsheetOptions: [],
    addError: "",
    permissions: {},
    selectMode: false,
  };

  pageData = {
    title: "Contractor Logbook",
    permission: "combined",
    permissionField: "contractor",
    url: "/contractor-list",
    scrollAnchor: u.getKey(),
  };

  listData = {
    deleteURL: "/api/delete-contractor-entries",
    spreadsheetURL: "/api/generate-contractor-spreadsheet",
    overviewURL: "/api/get-all-contractor",
    overviewLabel: "contractor-list",
    orderByField: "createdOn",
    orderByType: "descending",
    numRows: 20,
    checkboxPermissions: {},
    listOptions: [
      { label: "Tag Setting", ref: "macro", enabled: true, type: "list" },
    ],
  };

  componentDidMount = () => {
    const permissions = u.getPermissions("combined");
    this.setState({
      permissions: permissions,
      pageMenuButtons: [
        {
          label: "Delete",
          mobileLabel: "Delete Entry",
          ref: "delete",
          image: "/images/page-menu/delete.png",
          title: "Delete selected entry",
          enabled: permissions.contractor == 2,
        },
        {
          label: "Spreadsheet",
          mobileLabel: "Generate Spreadsheet",
          ref: "spreadsheet",
          image: "/images/page-menu/spreadsheet.png",
          title: "Generate spreadsheet from selection",
          enabled: permissions.contractor == 2,
        },
      ],
    });
  };

  onMenuOptionClicked = (ref, show, mobileNav) => {
    if (mobileNav) {
      const toggle = this.mobileSelect != ref;
      this.setState({
        selectMode: (ref == "spreadsheet" || ref == "delete") && toggle,
      });
      this.mobileSelect = toggle ? ref : null;
      for (var i = 0; i < mobileNav.length; i++) {
        const r = mobileNav[i].ref;
        const show = r == ref;

        if (show) {
          if (mobileNav[i].onClick) {
            mobileNav[i].onClick();
          } else if (mobileNav[i].type == "list") {
            this.refs["overview"].triggerListOptions(r, toggle);
          } else {
            this.refs[r].show(toggle);
          }
        } else {
          if (mobileNav[i].onClick) {
          } else if (mobileNav[i].type == "list") {
            this.refs["overview"].triggerListOptions(r, false);
          } else {
            this.refs[r].show(false);
          }
        }
      }
    } else {
      this.setState({
        selectMode: (ref == "spreadsheet" || ref == "delete") && show,
      });
      this.refs[ref].show(show);
    }
  };

  onToggleForm = (ref, show) => {
    this.refs["menu"].toggleForm(ref, show);
    this.mobileSelect = show ? ref : null;
  };

  onSelectChange = (selected) => {
    this.setState({ selected: selected });
  };

  onRefreshList = () => {
    this.refs["overview"].onRefreshList();
  };

  onContentGrabbed = (content) => {
    this.setState({ spreadsheetOptions: content.spreadsheetOptions });
  };

  render = () => {
    const mobileMenu = this.state.pageMenuButtons.concat(
      this.listData.listOptions
    );
    return (
      <AppLayout
        title={this.pageData.title}
        requiredPermission={this.pageData.permission}
        requiredField={this.pageData.permissionField}
        url={this.pageData.url}
      >
        <div className="page-error">{this.state.error}</div>
        <PageMenu
          id={this.pageData.scrollAnchor}
          title={this.pageData.title}
          ref="menu"
          buttons={this.state.pageMenuButtons}
          onMenuOptionClicked={this.onMenuOptionClicked}
        >
          <DeleteListItem
            scrollAnchor={this.pageData.scrollAnchor}
            ref="delete"
            reference="delete"
            url={this.listData.deleteURL}
            selected={this.state.selected}
            onToggleForm={this.onToggleForm}
            onRefreshList={this.onRefreshList}
          />
          <GenerateSpreadsheet
            scrollAnchor={this.pageData.scrollAnchor}
            ref="spreadsheet"
            url={this.listData.spreadsheetURL}
            options={this.state.spreadsheetOptions}
            reference="spreadsheet"
            selected={this.state.selected}
            onToggleForm={this.onToggleForm}
          />
        </PageMenu>
        <OverviewList
          ref="overview"
          selectMode={this.state.selectMode}
          url={this.listData.overviewURL}
          label={this.listData.overviewLabel}
          numRows={this.listData.numRows}
          orderByField={this.listData.orderByField}
          orderByType={this.listData.orderByType}
          onSelectChange={this.onSelectChange}
          registerReference={this.registerReference}
          onContentGrabbed={this.onContentGrabbed}
          onMutatedChange={this.onMutatedChange}
          checkboxPermissions={this.listData.checkboxPermissions}
        >
          {(content, index, onChange, onContentChange, registerRef) => {
            return (
              <ContractorItem
                key={index}
                index={index}
                content={content}
                onChange={onChange}
                onContentChange={onContentChange}
                registerReference={registerRef}
                permissions={this.state.permissions}
                isSuperUser={this.state.isSuperUser}
              />
            );
          }}
        </OverviewList>
        <MobileMenu content={mobileMenu} onClick={this.onMenuOptionClicked} />
      </AppLayout>
    );
  };
}

class ContractorItem extends React.Component {
  state = {
    error: "",
    step: "view",
    loading: false,
    loadText: "",
  };

  onAssign = () => {
    this.setState({ error: "" });
    const passNumber = this.refs["passNumber"].validate();
    if (!passNumber.valid) {
      this.setState({ error: passNumber.error });
      return;
    }

    this.setState({ loading: true, loadText: "Assigning Pass..." });
    const { content } = this.props;
    u.post({
      url: "/api/assign-contractor-pass",
      data: {
        contractorID: content.contractorID,
        passNumber: passNumber.value,
      },
      success: () => {
        console.log(
          "Pass assigned successfully",
          passNumber.value,
          this.props.index,
          u.getUserName()
        );
        this.props.onChange(passNumber.value, "passNumber", this.props.index);
        this.props.onChange(
          moment().format("YYYY-MM-DDTHH:mm:ss"),
          "assignedOn",
          this.props.index
        );
        this.props.onChange(
          u.getFullName(),
          "assignedByName",
          this.props.index
        );
        this.setState({ loading: false, step: "view" });
      },
      error: (error) => {
        this.setState({ loading: false, error: error });
      },
    });
  };

  onReturn = () => {
    this.setState({ error: "" });
    this.setState({ loading: true, loadText: "Returning Pass..." });
    const { content } = this.props;
    u.post({
      url: "/api/return-contractor-pass",
      data: {
        contractorID: content.contractorID,
      },
      success: () => {
        this.props.onChange(true, "returned", this.props.index);
        this.props.onChange(
          moment().format("YYYY-MM-DDTHH:mm:ss"),
          "returnOn",
          this.props.index
        );
        this.props.onChange(u.getFullName(), "returnByName", this.props.index);
        this.setState({ loading: false, step: "view" });
      },
      error: (error) => {
        this.setState({ loading: false, error: error });
      },
    });
  };

  render = () => {
    const content = this.props.content;
    const edit = this.props.permissions.contractor == 2;
    const url = "/api/update-contractor-info";
    const index = this.props.index + "";
    const id = content.contractorID;

    return (
      <div style={{ textAlign: "center" }}>
        <LoadGraphic active={this.state.loading} text={this.state.loadText} />
        <div className="list-segment-error">{this.state.error}</div>

        <Step active={this.state.step == "view"}>
          <div className="list-segment extended" style={{ textAlign: "left" }}>
            <div className="list-segment-item">
              <div className="list-segment-label">Contractor Name:</div>
              <div className="list-segment-input">
                <EditableBox
                  label="Contractor Name"
                  field="contractorName"
                  values={{ value: content.contractorName, enabled: false }}
                  rules={{ nullText: "None" }}
                  index={index}
                  id={id}
                  url={url}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Company Name:</div>
              <div className="list-segment-input">
                <EditableBox
                  label="Company Name"
                  field="companyName"
                  values={{ value: content.companyName, enabled: false }}
                  rules={{ required: true, nullText: "None" }}
                  index={index}
                  id={id}
                  url={url}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Contact Number:</div>
              <div className="list-segment-input">
                <EditableBox
                  label="Contact Number"
                  field="contactNumber"
                  values={{ value: content.contactNumber }}
                  rules={{ nullText: "None" }}
                  index={index}
                  id={id}
                  url={url}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Pass Number:</div>
              <div className="list-segment-input">
                <EditableBox
                  label="Pass Number"
                  field="passNumber"
                  values={{ value: content.passNumber }}
                  rules={{ nullText: "Not Issued" }}
                  index={index}
                  id={id}
                  url={url}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Pass Issued On:</div>
              <div className="list-segment-input">
                <EditSizeLabel>
                  {content.assignedOn
                    ? moment(content.assignedOn).format("DD MMM YYYY - h:mma")
                    : "Not Issued"}
                </EditSizeLabel>
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Pass Issued By:</div>
              <div className="list-segment-input">
                <EditSizeLabel nullText="Not Issued">
                  {content.assignedByName}
                </EditSizeLabel>
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Registered On:</div>
              <div className="list-segment-input">
                <EditSizeLabel nullText="None">
                  {moment(content.createdOn).format("DD MMM YYYY - h:mma")}
                </EditSizeLabel>
              </div>
            </div>
          </div>

          <div className="list-segment extended" style={{ textAlign: "left" }}>
            <div className="list-segment-item">
              <div className="list-segment-label">Purpose:</div>
              <div className="list-segment-input">
                <EditableSelect
                  label="Purpose"
                  field="purpose"
                  values={{
                    value: content.purpose,
                    options: ContractorPurpose,
                  }}
                  index={index}
                  id={id}
                  url={url}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Tenant:</div>
              <div className="list-segment-input">
                <EditSizeLabel>{content.tenantName}</EditSizeLabel>
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Tenant Unit:</div>
              <div className="list-segment-input">
                <EditSizeLabel>
                  {content.tenantBlock} {content.tenantUnit}
                </EditSizeLabel>
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Pass Returned:</div>
              <div className="list-segment-input">
                <EditableSelect
                  label="Pass Returned"
                  field="returned"
                  values={{
                    value: content.returned,
                    options: YesNoSelect,
                    enabled: false,
                  }}
                  rules={{ nullText: "No" }}
                  index={index}
                  id={id}
                  url={url}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Pass Returned On:</div>
              <div className="list-segment-input">
                <EditSizeLabel>
                  {content.returnOn
                    ? moment(content.returnOn).format("DD MMM YYYY - h:mma")
                    : "Not Returned"}
                </EditSizeLabel>
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Pass Returned By:</div>
              <div className="list-segment-input">
                <EditSizeLabel nullText="Not Returned">
                  {content.returnByName}
                </EditSizeLabel>
              </div>
            </div>
          </div>

          <div style={{ margin: "30px 0", textAlign: "center" }}>
            {!content.assignedOn ? (
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "assign", error: "" });
                }}
              >
                Assign Pass
              </Button>
            ) : null}
            {content.assignedOn && !content.return ? (
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "return", error: "" });
                }}
              >
                Return Pass
              </Button>
            ) : null}
          </div>
        </Step>

        <Step active={this.state.step == "assign"}>
          <div style={{ padding: "30px 0" }}>
            <h2>Assign Contractor Pass</h2>
            <div className="segment-full-item" style={{ fontSize: "14px" }}>
              <div className="segment-item-label">Pass Number:</div>
              <div className="segment-item-input">
                <Box
                  ref="passNumber"
                  label="Pass Number"
                  field="passNumber"
                  rules={{ nullText: "Not Issued" }}
                />
              </div>
            </div>
            <div className="segment-buttons">
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "view" });
                }}
              >
                Back
              </Button>
              <Button type="medium" onClick={this.onAssign}>
                Assign
              </Button>
            </div>
          </div>
        </Step>

        <Step active={this.state.step == "return"}>
          <div style={{ padding: "30px 0" }}>
            <h2 className="text-emphasis">Return Contractor Pass</h2>
            <div>Note. Confirm that pass has been collected?</div>
            <div className="segment-buttons">
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "view" });
                }}
              >
                Back
              </Button>
              <Button type="medium" onClick={this.onReturn}>
                Confirm
              </Button>
            </div>
          </div>
        </Step>
      </div>
    );
  };
}
